import { ComponentType } from 'react';
import { RegionsList } from './regions-list';

export const Regions: ComponentType = () => {
  return <RegionsList />;
};
